/**
    商品列表
**/
<template>
  <div class="paymentCenter">
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }"><i></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="paymentCenter_left">
          <div class="xunyouImg">
            <!-- <img
              class="xunyouText"
              :src="`${(userInfo.avatar!=undefined || userInfo.avatar!=null) ?userInfo.avatar:''}`"
              @click="$router.push('/')"
              alt=""
            /> -->
            <el-image  class="xunyouText" :src="`${userInfo.avatar ?userInfo.avatar:userImg.avatar}`">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
            <p v-if="userInfo.userName == null ? false : true">
              {{ userInfo.userName }}
            </p>
          </div>
          <div class="xunyouImg">
            <p class="clickmoney" @click="toMyCard('2')">
              <i class="el-icon-money"></i> 余额:
              <i>¥ {{ getUserPay.userMoney.toFixed(2) }}</i>
            </p>
            <p class="clickmoney" @click="toMyCard('6')">
              <i class="el-icon-s-cooperation"></i> 充值卡:
              <i>¥ {{ getUserPay.userRedpack.toFixed(2) }}</i>
            </p>
            <p>
              <i class="el-icon-coin"></i> 白条:
              <i>¥ {{ getUserPay.totalBalanceWhitebar.toFixed(2) }}</i>
            </p>
            <p>
              <i class="el-icon-bank-card"></i> 积分:
              <i>¥ {{ getUserPay.userPoints.toFixed(2) }}</i>
            </p>
          </div>
          <div class="xunyouImg money">
            <p class="sets" style="cursor: pointer" @click="bindPhoneHandle">
              <i class="el-icon-setting"></i> 设置支付密码
            </p>
          </div>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="paymentCenter_right">
          <el-tabs
            v-model="activeName"
            @tab-click="tabhandleClick"
            v-loading="loading"
          >
            <el-tab-pane name="1">
              <span slot="label"><i class="el-icon-date"></i> 交易查询</span>
              <div class="tab_pane_content">
                <el-table :data="payListArr" border style="width: 100%">
                  <el-table-column prop="abfid" label="商户订单">
                  </el-table-column>
                  <el-table-column prop="type" label="交易类型">
                      <template slot-scope="scope">
                        <span>{{orderStatus(scope.row.type)}}</span>
                      </template>
                  </el-table-column>
                  <el-table-column prop="amount" label="总付款额度">
                  </el-table-column>
                  <el-table-column prop="createTime" label="创建时间">
                  </el-table-column>
                  <!-- <el-table-column prop="status" label="支付状态">
                     <template slot-scope="scope">
                        <span>{{orderStatuspay(scope.row.status)}}</span>
                      </template>
                  </el-table-column> -->
                </el-table>
                <div class="pagination">
                  <!-- 分页组件 -->
                  <Pagination
                    v-bind:child-msg="pageparm"
                    @callFather="callFather"
                  ></Pagination>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="2">
              <span slot="label"
                ><i class="el-icon-money"></i> 账户余额
                <span class="badge-red"
                  >¥{{ getUserPay.userMoney.toFixed(2) }}</span
                ></span
              >
              <div class="tab_pane_content">
                <el-row class="moneyNum">
                  <el-col :span="12">
                    <div class="balance">
                      <div>
                        <i class="el-icon-bank-card"></i>
                      </div>
                      <div class="balanceNum">
                        <!-- <p>¥{{getUserPay.userMoney.toFixed(2)}}</p> -->
                        <p>
                          ¥<countTo
                            :startVal="startVal"
                            :endVal="getUserPay.userMoney"
                            :separator="','"
                            :decimals="2"
                            :duration="3000"
                            :autoplay="true"
                          ></countTo>
                        </p>
                        <span>可用余额</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="freezeBalance">
                      <div>
                        <i class="el-icon-bank-card"></i>
                      </div>
                      <div class="balanceNum">
                        <!-- <p>¥ {{getUserPay.userMoneyFrozen.toFixed(2)}}</p> -->
                        <p>
                          ¥<countTo
                            :startVal="startValFree"
                            :endVal="getUserPay.userMoneyFrozen"
                            :separator="','"
                            :decimals="2"
                            :duration="3000"
                            :autoplay="true"
                          ></countTo>
                        </p>
                        <span>冻结余额</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="tab_pane_content">
                      <el-table :data="tableData" border>
                        <el-table-column prop="amount" label="金额(元)">
                        </el-table-column>
                        <el-table-column  prop="type" label="交易类型">
                            <template slot-scope="scope">
                              <span>{{orderStatus(scope.row.type)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="时间">
                        </el-table-column>
                        <el-table-column prop="note" label="备注">
                        </el-table-column>
                      </el-table>

                      <!-- <el-pagination
                        class="pagination"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[5, 10, 20]"
                        :page-size="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="20"
                      >
                      </el-pagination> -->
                    </div>
                  </el-col>
                  <el-col :span="24" class="pagination">
                      <!-- 分页组件 -->
                    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane name='3'>
                            <span slot="label"><i class="el-icon-coin"></i> 信用支付</span>
                            <div>
                                www
                            </div>
                        </el-tab-pane> -->
            <el-tab-pane name="4">
              <span slot="label"><i class="el-icon-coin"></i> 余额提现</span>
              <div>
                <div class="applyMoney">
                  <el-button type="primary" v-show="isShow?true:false" @click="openapplyMoney" class="buttonBgd">申请提现</el-button>
                                    <el-button type="primary" v-show="!isShow?false:true" @click="closeapplyMoney" class="buttonBgd">关闭提现</el-button>
                </div>
                <div>
                  <el-form
                    ref="formLabelAlign"
                    :rules="rules"
                    label-width="80px"
                    :model="formLabelAlign"
                  >
                    <el-form-item label="提现金额" prop="trans_amount">
                      <el-input
                        v-model="formLabelAlign.trans_amount"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收款方式">
                      <el-input disabled placeholder="支付宝"></el-input>
                    </el-form-item>
                    <el-form-item label="收款账号"  prop="identity">
                      <el-input v-model="formLabelAlign.identity"></el-input>
                    </el-form-item>
                    <el-form-item label="收款人"  prop="type">
                          <el-input v-model="formLabelAlign.payeename"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="支付密码">
                            <el-input v-model="formLabelAlign.type" placeholder="验证您的身份，我们将在2个工作日内将提现金额转至您的提现账号中"></el-input>
                    </el-form-item> -->
                    <el-form-item label="">
                      <el-button
                        type="primary"
                        @click="getAlipayTransfer"
                        class="buttonBgd"
                        >确认提现</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="5">
              <span slot="label"><i class="el-icon-money"></i> 点击充值</span>
              <div class="isMycard">
                <p class="rechangNumber">充值金额: {{ rechargeNum }} 元</p>
                <el-radio v-model="payMethods" label="1"
                  ><el-image
                    class="payMethods_img"
                    :src="require('@/assets/img/zhifubao.png')"
                  ></el-image
                ></el-radio>
                <div>
                  <el-button type="primary" @click="orderNows" class="buttonBgd"
                    >确定支付</el-button
                  >
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="6">
              <span slot="label"
                ><i class="el-icon-date"></i> 我的充值卡
                <span class="badge-red"
                  >¥{{ getUserPay.userRedpack.toFixed(2) }}</span
                ></span
              >
              <!-- 查询我的充值卡的 -->
              <div>
                <el-row class="moneyNum">
                  <el-col :span="12">
                    <div style="background: #40bbea" class="balance">
                      <div>
                        <i class="el-icon-bank-card"></i>
                      </div>
                      <div class="balanceNum">
                        <!-- <p>{{getUserPay.userRedpack.toFixed(2)}}</p> -->
                        <p>
                          ¥<countTo
                            :startVal="startVal"
                            :endVal="getUserPay.userRedpack"
                            :separator="','"
                            :decimals="2"
                            :duration="3000"
                            :autoplay="true"
                          ></countTo>
                        </p>
                        <span>充值卡余额</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="freezeBalance">
                      <div>
                        <i class="el-icon-bank-card"></i>
                      </div>
                      <div class="balanceNum">
                        <!-- <p>{{getUserPay.userRedpackFrozen.toFixed(2)}}</p> -->
                        <p>
                          ¥<countTo
                            :startVal="startValFree"
                            :endVal="getUserPay.userRedpackFrozen"
                            :separator="','"
                            :decimals="2"
                            :duration="3000"
                            :autoplay="true"
                          ></countTo>
                        </p>
                        <span>冻结余额</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="tab_pane_content">
                      <el-table :data="myCardData" border>
                        <el-table-column prop="cardNumber" label="卡号">
                        </el-table-column>
                        <el-table-column prop="amount" label="金额（元）">
                        </el-table-column>
                        <el-table-column prop="createTime" label="时间">
                        </el-table-column>
                        <el-table-column prop="remark" label="备注">
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-col>
                  <el-col :span="24" class="pagination">
                    <!-- 分页组件 -->
                    <Pagination
                      v-bind:child-msg="pageparm"
                      @callFather="callFather"
                    ></Pagination>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <!-- 点击充值弹框 开始-->
    <el-dialog
      :visible.sync="rechargeVdialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <!-- :before-close="handleClose"> -->
      <div style="text-align: center">
        <el-input-number
          v-model="rechargeNum"
          controls-position="right"
          :min="10"
        ></el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rechargeVdialogVisible = false">取 消</el-button>
        <el-button type="primary" class="buttonBgd" @click="rechargeHandle"
          >确定充值</el-button
        >
      </span>
    </el-dialog>
    <!-- 点击充值弹框 结束-->

    <!-- 设置支付密码 开始 -->
             <el-dialog
                :visible.sync="bindPhoneboxdialog"
                :destroy-on-close = true
                :close-on-click-modal=false
                :before-close='resetbindPhoneForm'
                width="40%"
                title="设置支付密码"
                center
                >
                    <el-form :model="bindPhoneruleForm" status-icon :rules="rules" ref="bindPhoneruleForm" label-width="100px" class="demo-ruleForm">
                         <div v-if="step==1?true:false">
                             <el-form-item label="手机号码" prop="phone">
                                <el-input v-model="bindPhoneruleForm.phone" placeholder="请输入手机号" autocomplete="off" :value="userInfo.phonenumber" disabled></el-input>
                            </el-form-item>
                            <el-form-item prop="verificationCode" label="短信验证">
                                <el-input placeholder="请输入验证码" v-model="bindPhoneruleForm.verificationCode " >
                                    <template slot="append"><span v-if="!isShowButton" @click="sendMessage" style="cursor:pointer">发送短信</span></template>
                                    <template slot="append"><span v-if="isShowButton" style="cursor: not-allowed;">{{count}}秒后重新获取</span></template>
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="验证码" class="codeImgText" prop="code">
                                <el-input type="text" placeholder="验证码" v-model="bindPhoneruleForm.code">
                                <template slot="append">
                                    <div  @click="refreshCode" class="codeImg">
                                        <s-identify :identifyCode="identifyCode"></s-identify>
                                    </div>
                                </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <!-- <el-button type="primary" class="buttonBgd" @click="submitbindPhoneForm()">确定</el-button> -->
                                <el-button type="primary" class="buttonBgd" @click="submitbindPhoneForm()">下一步</el-button>
                                <!-- <el-button @click="resetbindPhoneForm()">取消</el-button> -->
                            </el-form-item>
                        </div>
                        <div v-if="step==2?true:false">
                          <el-form :model="numberruleForm" status-icon :rules="rules" ref="numberruleForm" class="demo-ruleForm">
                              <el-form-item label="支付密码" prop="newPass">
                                <el-input placeholder="请输入新密码"  type="password" v-model="numberruleForm.newPass" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item label="确认密码" prop="checkPass">
                                  <el-input placeholder="请确认密码"  type="password" v-model="numberruleForm.checkPass" autocomplete="off"></el-input>
                              </el-form-item>
                              <el-form-item>
                                  <el-button type="primary" class="buttonBgd" @click="submitPayPassword()">确定</el-button>
                                  <!-- <el-button type="primary" class="buttonBgd" @click="submitbindPhoneForm()">下一步</el-button> -->
                                  <el-button @click="resetbindPhoneForm()">取消</el-button>
                              </el-form-item>
                          </el-form>
                        </div>
                    </el-form>
            </el-dialog>
        <!-- 设置支付密码 结束 -->
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import {sendSms,querySendDetails,editPayPasw,payList,alipayPc } from '@/api/xunyou'
import { getRandomCode,dateFormat } from "@/api/order"
import countTo from "vue-count-to";
import SIdentify from '@/components/sidentify'
import { mapState } from "vuex";
import {
  recharge,
  alipayTransfer,
  getUserPay,
  recharge_card_turnover,
  balanceTurnover
} from "@/api/xunyou";
import consultationVue from '../myOrder/customerService/consultation.vue';
export default {
  computed: {
    ...mapState(['userImg']),
  },
  data() {
    return {
      // 左侧用户金额
      getUserPay: {},
      // 设置支付密码
      bindPhoneboxdialog:false,
      step:1,
      bindPhoneruleForm:{
          phone:JSON.parse(localStorage.getItem("userdata")).phonenumber||'',
          code:'',
          verificationPhoneCode:''
      },
      isShowButton:false,
        bizId: '',
        sendTime:'',
        count: '',
        timer: null,
        sendCode: true,
        identifyCodes: "1234567890", // 验证码的范围
        identifyCode: "",
        numberruleForm:{
          newPass:'',
          checkPass:'',
        },
      // 数字初始值
      startVal: 0,
      startValFree: 0,
      // isMycard:this.$route.query.isMycard||0, // 是否是从我的充值卡跳过来的
      isShow: false,
      rechargeVdialogVisible: false,
      rechargeNum: 1000,
      payMethods: "1", // 充值方式
      loading: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      activeName: "1",
      currentPage: 1,
      payListArr:[],
      tableData: [],
      orderMsg:[],
      // 我的充值卡查询
      myCardData: [
        // 我的充值卡查询
        {
          id: 1,
          money: -1222,
          type: "购物",
          date: "2016-05-02",
          add: "上海市普陀区金沙江路 1518 弄",
        },
        {
          id: 1,
          money: -12,
          type: "销售",
          date: "2016-12-02",
          add: "上海市普陀区金沙江路 1518 弄",
        },
        {
          id: 1,
          money: 1222,
          type: "购物",
          date: "2016-05-02",
          add: "上海市普陀区金沙江路 1518 弄",
        },
        {
          id: 1,
          money: -1222,
          type: "销售",
          date: "2016-03-02",
          add: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      // 分页参数
      pageparm: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 请求数据参数
      formInline: {
        pageSize: 10,
        pageNum: 1,
        uid: JSON.parse(localStorage.getItem("userdata")).userId,
      },

      formLabelAlign: {
        trans_amount: "", //订单总金额
        identity: "", // 收款账号
      },
      rules: {
        trans_amount: [{ required: true, message: "请输入", trigger: "blur" }],
        identity: [{ required: true, message: "请输入", trigger: "change" }],
        verificationCode:[{ required: true, message: "不能为空", trigger: ["blur", "change"] },],
         code: [{ required: true,
                    message: '请输入正确验证码',
                    trigger: ['blur'],
                    validator:(rule, value, callback) => {
                        if (value == '') {
                          callback(new Error('请输入验证码'));
                        } else if (this.identifyCode !== value) {
                          callback(new Error('验证码不正确，请重输入'));
                          // this.numberruleForm.code ='';
                          this.bindPhoneruleForm.code='';
                          this.refreshCode()
                        }else{
                          callback();
                        }
                      }
              }],
        newPass:[{ required: true,
             //  message: "不能为空",
              trigger: ["blur"],
              validator:(rule, value, callback) => {
                 let reg = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                 let result = reg.test(value);
                 if (value == '') {
                     callback(new Error('不能为空'));
                 }else if (!result) {
                     callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                 }else{
                     callback();
                 }
              }
         }],
        checkPass:[{ required: true,
                // message: "不能为空",
                 trigger: ["blur"],
                validator:(rule, value, callback) => {
                    let regs = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                    let results = regs.test(value);
                    if (value == '') {
                      callback(new Error('不能为空'));
                    }else if (!results) {
                        callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                    }else if (value != this.numberruleForm.newPass ) {
                      callback(new Error('两次密码不一致'));
                    }else{
                      callback();
                    }
                }
        }],
      },
    };
  },

  // 注册组件
  components: { Pagination, countTo,SIdentify },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    if (this.$route.fullPath.indexOf("tap") > 0) {
      this.activeName = this.$route.query.tap;
    }
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    this.getUserMoney();
    this.getMyCard();
    this.getbalanceTurnover()
    this.getPayList()
    this.setOrdermsg()
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      if(this.activeName==2){
        this.getbalanceTurnover()
      }else if(this.activeName==6){
        this.getMyCard();
      }else if(this.activeName==1){
        this.getPayList()
      }
    },
    //支付状态
    orderStatuspay(status){
      switch(status){
        case 1:
            return '成功'
            break;
        case 2:
            return '失败'
            break;
      }
    },
    //交易类型
    orderStatustype(status){
      switch(status){
        case 1:
            return '充值'
            break;
        case 2:
            return '购物'
            break;
        case 2:
            return '佣金'
            break;
      }
    },

    //   交易类型
    orderStatus(status){
        switch(status) {
            case 1:
                return '充值'
                break;
            case 2:
                 return '购物'
                break;
            case 3:
                 return '提现'
                break;
            case 4:
                 return '销售'
                break;
            case 5:
                 return '退货付款'
                break;
            case 6:
                 return '退货收款'
                break;
            case 7:
                 return '其他'
                break;
            // case 13:
            //      return '等待卖家收货确认'
            //     break;
            // case 14:
            //      return '等待卖家退款确认'
            //     break;
            // case 15:
            //      return '等待买家收款确认'
            //     break;
            // case 16:
            //      return '退款退货完成'
            //     break;
            // case 17:
            //      return '已拒绝退款'
            //     break;
            // case 18:
            //      return '已取消'
            //     break;
            // default:
            //     return '--'
      }
    },

    //   跳到我的充值卡
    toMyCard(activeName) {
      this.activeName = activeName;
      if (this.activeName == 2 || this.activeName == 6) {
        // 重置初始值
        this.startVal--;
      }
    },

    // --------------------设置支付密码 开始-------------------------
    //验证码
      randomNum(min, max) {
         return Math.floor(Math.random() * (max - min) + min);
      },
      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },
      makeCode(o, l) {
          for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
          ];
          }
      },

    bindPhoneHandle(){
      this.step=1;
      this.bindPhoneboxdialog = true
    },
    sendMessage(){
            sendSms({
                    TemplateCode: 'SMS_201652449',
                    phoneNumbers: this.bindPhoneruleForm.phone
            }).then((res) => {
              console.log(res);
              console.log(res.data.code);
                    if (res.data.code !== 0) {
                        return;
                    } else {
                    this.$message({
                        type: 'success',
                        message: '发送成功!'
                    });
                        //发送成功
                        const bizId = res.data.BizId;
                        this.bizId=bizId;
                        var nowDate = new Date();
                        var year = nowDate.getFullYear();
                        var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
                        : nowDate.getMonth() + 1;
                        var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
                        .getDate();

                        this.sendTime=year+''+month+''+day;

                        const TIME_COUNT = 60;
                        if (!this.timer) {
                    this.isShowButton= true
                                    this.count = TIME_COUNT;
                                    this.sendCode = false;
                                    this.timer = setInterval(() => {
                                        if (this.count > 0 && this.count <= TIME_COUNT) {
                                            this.count--;
                                        } else {
                        this.sendCode = true;
                        this.isShowButton= false
                                            clearInterval(this.timer);
                                            this.timer = null;
                                        }
                                    }, 1000);
                                }
                            }
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$message.error("发送短信验证码失败，请稍后再试！");
                    });
    },
    // 下一步
    submitbindPhoneForm(){
      this.$refs.bindPhoneruleForm.validate(valid => {
                  if (valid) {
                    const req ={
                          phones: this.bindPhoneruleForm.phone,
                          sendTime: this.sendTime,
                          bizId: this.bizId,
                          vcode: this.bindPhoneruleForm.verificationCode
                        }
                     querySendDetails(req)
                      .then((res) => {
                          if (res.code == 0) {
                              // if(res.data){
                                this.step = 2
                                // this.secondruleForm.username = this.ruleForm.username
                              // }else{
                              //   this.$message.error("用户不存在！");
                              // }
                          }else{
                            this.$message.error(res.msg);
                          }
                      })
                      .catch((err) => {
                        this.$message.error("校验失败，请稍后再试！");
                      });
                  }
          })
    },
    submitPayPassword(){
         this.$refs.numberruleForm.validate(valid => {
                  if (valid) {
                    const req ={
                        uid:this.userInfo.userId,
                        newpassword:this.numberruleForm.newPass,
                        commitpassword: this.numberruleForm.checkPass,
                        }
                     editPayPasw(req)
                      .then((res) => {
                          if (res.code == 0) {
                            this.resetbindPhoneForm()
                          }else{
                            this.$message.error(res.msg);
                          }
                      })
                      .catch((err) => {
                        this.$message.error("校验失败，请稍后再试！");
                      });
                  }
          })
    },

    // 取消
        resetbindPhoneForm(){
           this.bindPhoneboxdialog=false,
            this.bindPhoneruleForm={
                phone:JSON.parse(localStorage.getItem("userdata")).phonenumber||'',
                code:'',
                verificationCode:''
            }
            this.numberruleForm={
                newPass:'',
                checkPass:'',
            }
        },
    // --------------------设置支付密码 结束-------------------------

    //   切换tab
    tabhandleClick(tab, event) {
      if (this.activeName == 5) {
        this.rechargeVdialogVisible = true;
      } else if (this.activeName == 2 ) {
        this.getbalanceTurnover()
        // 重置初始值
        this.startVal--;
      }else if (this.activeName == 6) {
        this.getMyCard()
        // 重置初始值
        this.startVal--;
      }else if(this.activeName == 1){
        this.getPayList()
      }
    },

    // 查询用户的有关金额
    getUserMoney() {
      getUserPay({
        userId: this.userInfo.userId,
      })
        .then((res) => {
          console.log(res, "查询用户的有关金额");
          this.getUserPay = res.data;

        })
        .catch((err) => {
          this.$message.error("查询用户的有关金额失败，请稍后再试！");
        });
    },
    // //   提现
    // applyMoney(){
    //     this.isShow = !this.isShow
    // },

    /** 交易查询流水表 开始*/
      getPayList(){
        payList(this.formInline)
            .then((res) => {
              if (res.code == 0) {
                console.log(res)
                this.payListArr = res.rows
                 this.pageparm.total = res.total
                  // 分页赋值
                  this.pageparm.currentPage = this.formInline.pageNum
                  this.pageparm.pageSize = this.formInline.pageSize
              }
            })
            .catch((err) => {
              this.$message.error("余额流水查询失败，请稍后再试！");
            });
      },
    /** 交易查询流水表 结束*/

    /** 账户余额 开始*/
      // 余额流水
      getbalanceTurnover (){
        balanceTurnover(this.formInline)
            .then((res) => {
              if (res.code == 0) {
                console.log(res)
                this.tableData = res.rows
                console.log('余额流水查询',res)
                 this.pageparm.total = res.total
                  // 分页赋值
                  this.pageparm.currentPage = this.formInline.pageNum
                  this.pageparm.pageSize = this.formInline.pageSize
              }
            })
            .catch((err) => {
              this.$message.error("余额流水查询失败，请稍后再试！");
            });
      },


    /** 账户余额 结束*/

    /** 我的充值卡 开始*/
    getMyCard() {
      recharge_card_turnover(this.formInline)
        .then((res) => {
          if (res.code == 0) {
            this.myCardData = res.rows;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum;
            this.pageparm.pageSize = this.formInline.pageSize;
            this.pageparm.total = res.total;
          }
        })
        .catch((err) => {
          this.$message.error("查询我的充值卡失败，请稍后再试！");
        });
    },

    /** 我的充值卡 结束*/

    // 确认提现
    getAlipayTransfer() {
      this.$refs.formLabelAlign.validate((valid) => {
        if (valid) {
          const req = {
            trans_amount: this.formLabelAlign.trans_amount, //订单总金额
            product_code: "TRANS_ACCOUNT_NO_PWD",
            out_biz_no: `DD-${new Date().getTime()}`, // 自动生成不一样的订单就行
            identity: this.formLabelAlign.identity,
            identity_type: "ALIPAY_USER_ID",
            biz_scene:'DIRECT_TRANSFER',
            name:this.formLabelAlign.payeename,
            product_code:'STD_APP_TRANSFER'
            // payee_info: {
            //   identity: this.formLabelAlign.identity,
            //   identity_type: "ALIPAY_USER_ID",
            // },
          };
          alipayTransfer(req)
            .then((res) => {
              console.log(res, "确认体现");
              this.$message({
                type: "info",
                message: "提交成功",
              });
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("付款失败，请稍后再试！");
            });
        }
      });
    },

    //   点击充值
    rechargeHandle() {
      if (this.rechargeNum == "" || this.rechargeNum == null) {
        this.$message({
          type: "info",
          message: "请填入充值金额数",
        });
        return;
      }
      // alert('充值成功')
      this.rechargeVdialogVisible = false;
      //  recharge(req)
      //     .then(res => {

      //     })
      //     .catch(err => {
      //       this.$message.error('充值失败，请稍后再试！')
      //  })
    },
    //生成模拟订单
    setOrdermsg(){
     const ordermsg = getRandomCode()
     this.orderMsg = ordermsg
    },
    // 确认付款
    orderNows() {
      alipayPc({
        passbackParams: `${this.$baseUrl}/custom/xunyou/xy_personvalue/api/deal`,
        timeoutExpress: "30m",
        totalAmount: this.rechargeNum,
        outTradeNo:this.orderMsg,
        goodsTitle: "充值",
        description: "充值"
      }).then(res=>{
         const payDiv = document.getElementById("payDiv");
          if (payDiv) {
            document.body.removeChild(payDiv);
          }
          const div = document.createElement("div");
          div.id = "payDiv";
          div.innerHTML = res.msg;						//支付宝提供的form标签跳转到支付宝支付页面
          document.body.appendChild(div);
		  console.log(res.msg)
          document.getElementById("payDiv").getElementsByTagName("form")[0].submit();   //触发跳转
      }).catch((err) => {
        this.editFormVisible = false;
        this.loading = false;
        this.$message.error("付款失败，请稍后再试！");
      });
      //   alipay({
      //         outTradeNo:this.orderGoodsInfo[0].orderNumber, //订单号
      //         subject:this.orderGoodsInfo[0].title, // 订单标题
      //         totalAmount:this.account || '0.1' // 金额数目
      //     })
      //     .then(res => {
      //         const payDiv = document.getElementById('payDiv');
      // 			if (payDiv) {
      // 				document.body.removeChild(payDiv);
      // 			}
      // 			const div = document.createElement('div');
      // 			div.id = 'payDiv';
      // 			div.innerHTML = res.data;
      // 			document.body.appendChild(div);
      // 			document
      // 				.getElementById('payDiv')
      // 				.getElementsByTagName('form')[0]
      // 				.submit();
      //     })
      //     .catch(err => {
      //       this.editFormVisible = false
      //       this.loading = false
      //       this.$message.error('付款失败，请稍后再试！')
      //     })
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style scoped lang="less">
.paymentCenter {
  width: 1200px;
  margin: auto;
  padding: 20px;
  box-sizing: border-box;
  .breakcrumbHeader {
    margin: 15px 0;
  }
  .paymentCenter_left,
  .paymentCenter_right {
    background: white;
    padding: 20px;
    box-sizing: border-box;
  }
  .paymentCenter_left {
    .xunyouImg {
      text-align: center;
      width: 100%;
      border-bottom: 1px solid #ccc;
      .xunyouText {
        border-radius: 50%;
        width: 160px;
        height: 160px;
      }
      p {
        font-size: 16px;
        margin: 20px 0;
      }
      .clickmoney {
        cursor: pointer;
      }
      .clickmoney:hover {
        color: #ff6700;
      }
    }
    .money .sets:hover {
      color: #ff6700;
    }
  }
  .paymentCenter_right {
    /deep/ thead.has-gutter {
      color: #333;
      text-align: center;
    }
    .pagination {
      text-align: end;
      margin-top: 20px;
      /deep/ li.number {
        width: 40px;
      }
      /deep/input[readonly],
      input[readonly="readonly"] {
        background-color: white;
      }
    }
    .moneyNum.el-row {
      margin-bottom: 30px;
      .el-col {
        height: 100%;
      }
      height: 80px;
      background: red;
      .balance,
      .freezeBalance {
        height: 100%;
        background: #68b828;
        padding: 15px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        // margin-left: 20px;
        // font-size: 25px;
        color: white;
        i {
          font-size: 55px;
        }
        .balanceNum {
          padding: 0 20px;
          p {
            font-size: 28px;
          }
        }
      }
      .freezeBalance {
        background: #f7aa47;
      }
    }

    .payMethods_img {
      // margin: 20px;
      border: 1px solid #ccc;
      width: 180px;
    }
    .rechangNumber {
      color: #9c9c9c;
      font-size: 16px;
      margin: 15px;
    }

    // 账户余额 充值卡
    .badge-red {
      background-color: #cc3f44;
      padding: 2px 5px;
      border-radius: 15px;
      color: white;
    }

    //余额提现
    .applyMoney {
      background: red;
      background-color: #eee;
      border-color: #eee;
      color: #333;
      padding: 0 20px;
      margin-bottom: 20px;
    }
  }
  button.el-button.buttonBgd.el-button--primary {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 18px;
    margin: 20px 0;
  }
}
.pagination {
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;
    color: #fff;
    width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next,
  /deep/.el-pagination.is-background .btn-prev,
  /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/siteNavigation/paymentCenter.vue